<script>
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import ErrorMessageHandler from "../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import NoIssueData from "../../../../components/NoDataPage/NoIssueData.svelte";
	import client from "../../../../services/client";
	import {
		errorMessage,
		vehicleId,
		issueDetail,
	} from "../../../../store/store";
	import { onMount } from "svelte";
	import "@splidejs/svelte-splide/css";
	import Exterior from "./ApprovedIssueTabs/Exterior.svelte";
	import Drive from "./ApprovedIssueTabs/Drive.svelte";
	import Tabs from "../../../../components/Tabs/Tabs.svelte";
	import { navigate } from "svelte-routing";

	let issues = [];
	let activeTab;

	onMount(async () => {
		try {
			// loading.set(true);
			issueDetail.set("");
			const res = await client(
				`/v0/Issue/GetActiveVehicleIssues/${$vehicleId}`,
				{
					method: "GET",
					version: "Tasking",
				}
			);
			issues = res.data.data;
			issueDetail.set(issues);

			// NOTE: this previously had an `else if` whose condition was the same
			// two checks in the opposite order, so `activeTab = 1` was
			// unreachable. Removed without changing behaviour -- but if the
			// intent was "exterior issues -> tab 2, drive issues -> tab 1",
			// that never worked and needs a product decision.
			if (
				Object.keys(issues.exteriorIssues).length > 0 ||
				Object.keys(issues.driveIssues).length > 0
			) {
				activeTab = 2;
			}
			// loading.set(false);
		} catch (err) {
			// loading.set(false);
			console.log(err.response);
		}
	});

	// Do not change readonly options later, such as `type`, `preloadPages`, etc.
	const options = {
		rewind: true,
		gap: "1px",
		autoWidth: true,
		height: "15rem",
		arrows: true,
	};

	let items = [
		{
			label: "Drive",
			value: 1,
			component: Drive,
		},
		{
			label: "Exterior",
			value: 2,
			component: Exterior,
		},
	];

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row class="me-3 ">
	<Col xs={12}>
		<div>
			{#if !issues}
				<NoIssueData />
			{:else if issues.vehicleMake == undefined}
				<div class="text-center">... Fetching issue data</div>
			{:else if Object.keys(issues.exteriorIssues).length === 0}
				<div>
					<NoIssueData />
				</div>
			{:else}
				<ErrorMessageHandler message={err} />

				<Col>
					<Row class="carousel-detail ">
						<Col xs={12} class="mt-4 px-2">
							<Col
								xs={12}
								class="d-flex justify-content-between px-2 "
							>
								<div class="me-2">
									<p
										class="status-bar-info-issue status-bar-info-3"
									>
										Approved
									</p>
								</div>
							</Col>
							<Col
								xs={12}
								class="d-flex justify-content-start px-2"
							>
								<div class="mx-0">
									<h4 class="link-hover">
										<!-- svelte-ignore a11y-click-events-have-key-events -->
										<b
											class="link-text-hover"
											on:click={() =>
												navigate(
													`/car-management/details/${$vehicleId}`
												)}
										>
											{issues.vehicleMake +
												" " +
												issues.vehicleModel +
												" " +
												issues.vehicleNumber}
										</b>
									</h4>
								</div>
							</Col>
							<Col
								xs={6}
								class="d-flex justify-content-start px-2"
							>
								<div class="me-2">
									<p
										class="status-bar-info status-bar-info-1"
									>
										Color: {issues.vehicleColor}
									</p>
								</div>
							</Col>
						</Col>
						<Tabs
							{items}
							{options}
							{activeTab}
							compareMode={true}
						/>
					</Row>
				</Col>
			{/if}
		</div>
	</Col>
</Row>

<style>
	:global(.carousel-detail) {
		border: 0.5px solid gray;
		margin-left: 0px !important;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0px 0px 1px 1px rgba(154, 146, 146, 0.5);
	}
</style>
